import React from "react"

import { Input } from "@coval/ui"

import type { MetricRecordData } from "@/types/metrics/contracts"

type FilterSelectionRenderer = (
  value: string,
  onValueChange: (value: string) => void,
) => React.ReactNode

type SingleOutputAlertFormRenderer = (
  value: string,
  onValueChange: (value: string) => void,
) => React.ReactNode

type EditorMetadataRenderer = (
  metricRecordData: MetricRecordData,
  onChange: (metric: MetricRecordData) => void,
  textAreaRef?: React.RefObject<HTMLTextAreaElement>,
) => React.ReactNode

type MetadataFieldRenderer = (
  metricRecordData: MetricRecordData,
) => React.ReactNode

type MetricTypeRenderer = () => React.ReactNode

export const renderDefaultFilterSelection: FilterSelectionRenderer = (
  value,
  onValueChange,
) => {
  return (
    <Input
      type="text"
      value={value}
      onChange={(e) => onValueChange(e.target.value)}
      placeholder="Value"
      className="w-24"
    />
  )
}

export const renderDefaultSingleOutputAlertForm: SingleOutputAlertFormRenderer =
  (value, onValueChange) => {
    return (
      <Input
        placeholder="Enter value"
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className="flex-1"
      />
    )
  }

export const renderDefaultAggregateAlertForm = (
  outputType: string | undefined,
  threshold: string,
  onThresholdChange: (value: string) => void,
  matchValue?: string,
  onMatchValueChange?: (value: string) => void,
): React.ReactNode => {
  if (outputType === "float") {
    return (
      <Input
        placeholder="Threshold"
        value={threshold}
        onChange={(e) => onThresholdChange(e.target.value)}
        type="number"
        className="flex-1"
      />
    )
  }

  return (
    <div className="flex gap-2 flex-1">
      <Input
        placeholder="Fraction (0-1)"
        value={threshold}
        onChange={(e) => onThresholdChange(e.target.value)}
        type="number"
        step="0.01"
        min="0"
        max="1"
        className="w-32"
      />
      <Input
        placeholder="Match value"
        value={matchValue || ""}
        onChange={(e) => (onMatchValueChange || (() => {}))(e.target.value)}
        className="flex-1"
      />
    </div>
  )
}

export const renderEmptyEditorMetadata: EditorMetadataRenderer = () => null

export const renderDefaultReadOnlyMetadata = (
  metricRecordData: MetricRecordData,
): React.ReactNode => {
  const question = metricRecordData.metric_metadata?.question
  if (!question) {
    return null
  }

  return (
    <div>
      <p className="text-sm font-medium text-coval-text">Metric Prompt</p>
      <p className="whitespace-pre-wrap text-sm text-coval-text">{question}</p>
    </div>
  )
}

export const renderEmptyMetadataField: MetadataFieldRenderer = () => null

export const renderEmptyMetricType: MetricTypeRenderer = () => null
